module.exports = __webpack_public_path__ + "static/img/6a.fd2e7f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/6a.jpg
// module id = nxOZ
// module chunks = 1